<template>
  <Loader :show="loading" />
  <AuthLayout>
    <BrandLogo size="lg" />
    <p class="mt-3 text-zinc-400">A casa de apostas oficial dos bagres.</p>

    <form class="mt-8 space-y-5" @submit.prevent="login">
      <div>
        <label class="label" for="username">Usuário</label>
        <input id="username" v-model="auth.username" class="input h-12" :class="{ invalid: v$.username.required.$invalid && submited }"
          autocomplete="username" autocapitalize="none" placeholder="Seu usuário">
        <p v-if="v$.username.required.$invalid && submited" class="mt-1 text-xs text-loss">Campo necessário</p>
      </div>
      <div>
        <label class="label" for="password">Senha</label>
        <div class="relative">
          <input id="password" v-model="auth.password" class="input h-12 pr-12"
            :class="{ invalid: v$.password.required.$invalid && submited }" :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password" placeholder="Sua senha">
          <button type="button" @click="showPassword = !showPassword"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-brand" aria-label="Mostrar senha">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
              <path
                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
            </svg>
          </button>
        </div>
        <p v-if="v$.password.required.$invalid && submited" class="mt-1 text-xs text-loss">Campo necessário</p>
      </div>
      <button id="loginButton" type="submit" class="btn-primary w-full h-12 text-base">Entrar</button>
    </form>

    <div class="mt-8 pt-6 border-t border-ink-700 flex items-center justify-between text-sm">
      <p class="text-zinc-400">Não tem conta?</p>
      <span class="font-semibold text-brand">Pede pro leozamagro</span>
    </div>

    <p class="mt-10 flex items-center gap-2 text-xs text-zinc-600">
      <span class="chip border border-zinc-700 text-zinc-500">18+</span>
      Jogue com responsabilidade.
    </p>
  </AuthLayout>
</template>

<script setup>
import useVuelidate from "@vuelidate/core";
import { reactive, computed, ref } from "vue";
import { useRouter } from "vue-router";
import { required } from "@vuelidate/validators";
import Loader from '@/components/Loader.vue';
import BrandLogo from '@/components/BrandLogo.vue';
import AuthLayout from '@/components/AuthLayout.vue';
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const router = useRouter();
const loading = ref(false)
const showPassword = ref(false)

const auth = reactive({
  username: null,
  password: null
})

const rules = computed(() => {
  return {
    username: { required },
    password: { required },
  };
});

const v$ = useVuelidate(rules, auth);

const submited = ref(false)
const login = async () => {
  const result = await v$.value.$validate();
  submited.value = true
  if (!result) return
  let login = new FormData();
  login.append("username", auth.username);
  login.append("password", auth.password);
  loading.value = true
  try {
    const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/login`, login);
    if (response.status === 200) {
      localStorage.setItem('accesToken', response.data.access_token)
      router.push({ 'name': 'bets' })
    }
  } catch (error) {
    toast(error.response?.data?.detail || 'Não foi possível entrar', {
      "type": "info",
    })
  } finally {
    loading.value = false
  }
}
</script>
